import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class NotificationsRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get index() {
    return this.router.createRouteData({ name: 'NotificationsIndex' })
  }
}
